// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__FsK77","large":"styles_large__OslUr"};